const $ = id => document.querySelector(id);

export const replayButton = $('#canvas #rerun');
export const replayButton2 = $('#canvas #rerun2');
export const deathFilter = $('.corona-box #deaths');
export const stayFilters = document.querySelectorAll('.corona-box .staying');
export const graphElement = $('.corona-box #graph');
export const replayElement = $('.corona-box #replay');
export const applyOptions = $('.corona-box #apply');
export const dotsWrapper = $('.corona-box .dots-wrapper');
export const userInputsWrapper = $('.corona-box .user-inputs-wrapper');
export const titleDots = $('.playground #title-dots');
export const noteDots = $('.playground #note-dots');
export const replaySection = $('.playground #replay');
export const whatsappShare = document.querySelector('#js-whatsapp');
export const fbShare = document.querySelector('#js-fb');
export const twitterShare = document.querySelector('#js-twitter');
export const linkedInShare = document.querySelector('#js-linkedin');
